export const TOKEN_WEB_NAME = 'token_zetaxsoft'
export const PASS_KEY_CRYPTO = 'etax'